import { render, staticRenderFns } from "./templateTableauStats.vue?vue&type=template&id=4793dafd&scoped=true&"
import script from "./TableauStats.vue?vue&type=script&lang=js&"
export * from "./TableauStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793dafd",
  null
  
)

export default component.exports